import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class TrainingsServices {
  getTrainings = params =>
    AxiosClient.get("/api/app/capacitacion_curso/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getTraining = id =>
    AxiosClient.get(`/api/app/capacitacion_curso/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveTrainings = data =>
    AxiosClient.post("/api/app/capacitacion_curso/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editTrainings = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_curso/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteTrainings = id =>
    AxiosClient.delete(`/api/app/capacitacion_curso/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new TrainingsServices();